import classNames from 'classnames';
import * as React from 'react';
import { Body, Button, Loading } from 'vet-bones/design-system/components';

import * as copy from 'src/templates/copy';

import styles from 'src/components/dataSourceSelection/selectionCard.module.scss';

export type SelectionCardProps = {
  /** The icon element to display */
  icon: React.ReactNode;
  /** The label text to display */
  label: string;
  /** Click handler for the card's connect button */
  onSelect: () => void;
  /** Whether the card is in a loading state */
  isLoading?: boolean;
  /** Visual variant - 'new' shows dashed border for "new connection" cards */
  variant?: 'default' | 'new';
  /** Optional tooltip text for the card */
  tooltipText?: string;
  /** Optional test ID for the card container */
  testId?: string;
};

export const SelectionCard: React.VFC<SelectionCardProps> = ({
  icon,
  label,
  onSelect,
  isLoading = false,
  variant = 'default',
  tooltipText,
  testId,
}) => {
  return (
    <div
      className={classNames(styles.card, {
        [styles.cardNew]: variant === 'new',
      })}
      data-testid={testId}
      title={tooltipText}
    >
      {isLoading ? (
        <div className={styles.cardLoading}>
          <Loading size="sm" />
        </div>
      ) : (
        <>
          <div className={styles.cardConnectButton}>
            <Button onClick={onSelect} size="sm" variant="secondary">
              {
                copy.components.virtualGraphPreviewDialog.connectionSelection
                  .connect
              }
            </Button>
          </div>
          <div className={styles.cardIcon}>{icon}</div>

          <Body
            className={styles.cardLabel}
            ellipsize
            size="md"
            weight="semibold"
          >
            {label}
          </Body>
        </>
      )}
    </div>
  );
};
